<template>
  <el-dialog
    :visible.sync="visible"
    width="480px"
    append-to-body
    :close-on-click-modal="false"
    :show-close="false"
    custom-class="volume-submit-success-dialog"
  >
    <div class="success-popup">
      <div class="popup-header">
        <div class="header-icon">
          <i class="el-icon-document-checked"></i>
        </div>
        <div class="main-title">约量提交成功</div>
        <div class="sub-title">SUBMITTED SUCCESSFULLY</div>
      </div>
      <div class="popup-content">
        <div v-if="qrCodeUrl" class="qrcode-wrap">
          <el-image
            class="qrcode-img"
            :src="qrCodeUrl"
            fit="contain"
            :preview-src-list="[qrCodeUrl]"
          />
        </div>
        <div class="follow-title">微信关注企业服务号</div>
        <div class="follow-desc">可快速接收约量消息反馈结果</div>
        <el-button class="back-btn" @click="handleClose">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'VolumeSubmitSuccessDialog',
  props: {
    qrCodeUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    close() {
      this.visible = false
    },
    handleClose() {
      this.close()
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.success-popup {
  overflow: hidden;
  border-radius: 8px;
}

.popup-header {
  position: relative;
  padding: 32px 24px 48px;
  text-align: center;
  background: linear-gradient(135deg, #b899ff 0%, #9266ff 55%, #7a4dff 100%);
  color: #fff;
}

.header-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-bottom: 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  font-size: 28px;
}

.main-title {
  font-size: 22px;
  font-weight: 700;
  line-height: 30px;
}

.sub-title {
  margin-top: 4px;
  font-size: 12px;
  letter-spacing: 1px;
  opacity: 0.85;
}

.popup-content {
  padding: 24px 32px 28px;
  text-align: center;
  background: #fff;
}

.qrcode-wrap {
  display: flex;
  justify-content: center;
  margin: 16px 0;
}

.qrcode-img {
  width: 180px;
  height: 180px;
  border-radius: 4px;
  border: 1px solid #f0f0f0;
}

.qrcode-img ::v-deep .el-image__inner {
  border-radius: 4px;
}

.follow-title {
  font-size: 14px;
  color: #333;
}

.follow-desc {
  margin-top: 8px;
  font-size: 12px;
  color: #666;
}

.back-btn {
  width: 100%;
  height: 44px;
  margin-top: 24px;
  padding: 0;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  color: #9266ff;
  background-color: #f3eeff;
}

.back-btn:hover,
.back-btn:focus {
  color: #9266ff;
  background-color: #ebe3ff;
}
</style>

<style>
.volume-submit-success-dialog {
  border-radius: 8px;
  overflow: hidden;
}

.volume-submit-success-dialog .el-dialog__header {
  display: none;
}

.volume-submit-success-dialog .el-dialog__body {
  padding: 0;
}
</style>
